import { type AccordionSummaryProps } from "@mui/material/AccordionSummary";
import { Component, ExpandIcon } from "./styles";

export function SectionTitle(props: AccordionSummaryProps) {
  return <Component {...props} expandIcon={<ExpandIcon />} component="h3" />;
}
